import React from 'react';
import ContentBox from '../../common/ContentBox';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import InvestmentsGraph from './components/InvestmentsGraph';
import InvestmentsRepartitionGraph from './components/InvestmentsRepartitionGraph';

const InvestmentTicketsTab: React.FC = () => {
    const { t } = useTranslation();

    return <>
        <ContentBox proportion={1}>
            <Box display={"flex"} flexDirection={"column"} gap={"10px"}>
                <Typography fontSize={"18px"} lineHeight={"21.94px"} fontWeight={"600"}>{t('PortfolioDetailsInvestmentTickets1')}</Typography>
                <InvestmentsGraph />
            </Box>
        </ContentBox>
        <ContentBox proportion={1}>
            <Box display={"flex"} flexDirection={"column"} gap={"10px"}>
                <Typography fontSize={"18px"} lineHeight={"21.94px"} fontWeight={"600"}>{t('PortfolioDetailsInvestmentTickets2')}</Typography>
                <InvestmentsRepartitionGraph />
            </Box>
        </ContentBox>
    </>;
}

export default InvestmentTicketsTab;